(function() {
  'use strict';

  angular
    .module('observatoireApp')
    .service('AutorisationsMinieresService', AutorisationsMinieresService);

  /** @ngInject */
  AutorisationsMinieresService.$inject = ['$http'];
  function AutorisationsMinieresService($http) {
    var service = {
      getAllAutorisationsMinieres: getAllAutorisationsMinieres,
      getAutorisationMiniereById: getAutorisationMiniereById,
      searchAutorisationsMinieres: searchAutorisationsMinieres,
      getFilterData: getFilterData
    };

    return service;

    function getAllAutorisationsMinieres() {
      return $http.get('/api/autorisations-minieres')
        .then(function(response) {
          return response.data;
        });
    }

    function getAutorisationMiniereById(id) {
      console.log('Service - Récupération de l\'autorisation avec ID:', id);
      return $http.get('/api/autorisations-minieres/' + id)
        .then(function(response) {
          console.log('Service - Réponse reçue:', response);
          return response.data;
        })
        .catch(function(error) {
          console.error('Service - Erreur lors de la récupération de l\'autorisation avec ID ' + id + ':', error);
          // Propager l'erreur pour que le contrôleur puisse la gérer
          return Promise.reject(error);
        });
    }

    function searchAutorisationsMinieres(params) {
      return $http.get('/api/autorisations-minieres/search', { params: params })
        .then(function(response) {
          return response.data;
        });
    }

    function getFilterData() {
      return $http.get('/api/autorisations-minieres/filter-data')
        .then(function(response) {
          return response.data;
        });
    }
  }
})();
